import { render, staticRenderFns } from "./aiEventList.vue?vue&type=template&id=2c8d5b30&scoped=true"
import script from "./aiEventList.vue?vue&type=script&lang=js"
export * from "./aiEventList.vue?vue&type=script&lang=js"
import style0 from "./aiEventList.vue?vue&type=style&index=0&id=2c8d5b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d5b30",
  null
  
)

export default component.exports